<template>
  <header class="header">
    <section class="header-center">
        <section class="line med logo-show" style="margin-right:27px;cursor:pointer">
          <a class="v-logo logo-show" @click="$router.push('/')"><img src="../assets/img/WechatIMG17.png" /></a>
        </section>
        <nav class="line med">
          <ul class="header-ul">
            <li :class="['header-li', $route.path == '/instant' ? 'selected' : '']" @click="$router.push('/instant')">即付问卷<span class="linehover"></span></li>
            <li :class="['header-li', $route.path == '/cash' ? 'selected' : '']" @click="$router.push('/cash')">现金问卷<span class="linehover"></span></li>
            <li :class="['header-li', $route.path == '/point' ? 'selected' : '']" @click="$router.push('/point')">点子问卷<span class="linehover"></span></li>
            <li :class="['header-li', $route.path == '/profile' ? 'selected' : '']" @click="$router.push('/profile')">我的点子<span class="linehover"></span></li>
          </ul>
        </nav>
        <!-- <section class="line med placeholder" style="margin-left:200px"></section> -->
        <template v-if="isLogin">
          <div v-if="isLogin" class="line med login-after avatar-show" @click="toggleLogouMenu">
            <img class="avatar avatar-show" :src="headimage"/>
            <p class="nickname avatar-show">{{ nickname }}</p>
          </div>
        </template>
        <template v-else>
          <span v-if="$route.path != '/login' && $route.path != '/follow'" class="line med login" style="cursor:pointer" @click="$router.push('/login')">登录</span>
        </template>

        <!-- <div class="logout-bg" v-if="isLogoutMenu" @click="isLogoutMenu = false"> -->
          <div class="logout-menu" v-if="isLogoutMenu" @click="logout">退出登录</div>
        <!-- </div> -->
        
    </section>
  </header>
</template>

<script>
import { isLogin, getCookie } from '../utils';

export default {
  name: 'AppHeader',
  data() {
    return {
      isLogin: false,
      isLoginPage: false,
      headimage: '',
      nickname: '',
      isLogoutMenu: false
    }
  },

  mounted() {
    this.isLogin = isLogin();
    if (this.isLogin) {
      this.headimage = getCookie('headimage');
      this.nickname = getCookie('nickname');
    }
  },

  methods: {
    toggleLogouMenu() {
      this.isLogoutMenu = !this.isLogoutMenu;

      if (this.isLogoutMenu) {
        setTimeout(() => {
          if (this.isLogoutMenu) {
            this.isLogoutMenu = false;
          }
        }, 5000);
      }
    },

    logout() {
      this.$axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT/wxlogin/LoginOut').then(res => {
        console.log(res);
        this.isLogoutMenu = false;
        this.$router.replace('/login')
      })
    }
  },

  watch:{
    $route(to,from){
      this.isLogin = isLogin();
      if (this.isLogin) {
        this.headimage = getCookie('headimage');
        this.nickname = getCookie('nickname');
      }
      console.log(to.path);
      if (to.path == '/login' || to.path == '/follow') {
        this.isLoginPage = true
      }else {
        this.isLoginPage = false
      }
    },
  },
}
</script>


<style>
.header .login-after{
  width: 50px;
  cursor: pointer;
  float: right;
  margin-top: 4px;
}
.header .nickname{
  font-size: 10px;
  text-align: center;
  width: 50px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 5px;
}
.header .avatar{
  width:32px;
  height: 32px;
  border-radius: 32px;
  margin: 0 auto;
  display: block;
  overflow: hidden;
}

.header .header-center{
  /* width: 1200px; */
  /* width: 90%; */
  margin:0 auto;
}
.header .wx-text{
  font-size: 15px;
  cursor: pointer;
}
.header .search{
  width: 300px;
  height: 34px;
  margin:0px 60px 0px 16px;
  background: rgba(0,0,0,0.2);
  border-radius: 100px;
  position: relative;

  transition:background 0.5s;
  -moz-transition:background 0.5s; /* Firefox 4 */
  -webkit-transition:background 0.5s; /* Safari and Chrome */
  -o-transition:background 0.5s; /* Opera */
}
.header .search:hover{
  background:rgba(0,0,0,0.7);

}

.header .search-input{
  position: absolute;
  font-size: 12px;
  color: #FFFFFF;
  background-color: transparent;
  top: 10px;
  left: 20px;
  width: 200px;
  z-index: 2;
}
.header{
  background: #403E49;
  color: #D8D8D8;
  height: 60px;
}
.header .add-img{
  width: 34px;
  height: 34px;
  border-radius: 34px;
  cursor: pointer;
}
.header .add-icon{
  width: 34px;
  height: 34px;
  display: inline-block;
  border-radius: 100%;
  background:#33313A url(/img/creat_vote.png) no-repeat center top;

  transition:background 0.5s;
  -moz-transition:background 0.5s; /* Firefox 4 */
  -webkit-transition:background 0.5s; /* Safari and Chrome */
  -o-transition:background 0.5s; /* Opera */
}
.header .add-icon:hover{
  background-color:rgba(0,0,0,0.7);
  background-position: center bottom;

}
.header .v-logo{
  float: left;
  width: 106px;
  height: 36px;
}
.header .v-logo > img{
  width: 106px;
  height: 36px;
}
.header .header-li{
  float:left;
  font-size: 14px;
  height: 60px;
  /* width: 100px; */
  text-align: center;
  line-height: 60px;
  cursor: pointer;
  background: #403E49;
  position: relative;
  z-index: 10;

  transition:background 1s;
  -moz-transition:background 1s; /* Firefox 4 */
  -webkit-transition:background 1s; /* Safari and Chrome */
  -o-transition:background 1s; /* Opera */
}
.header .linehover{
  position: absolute;
  z-index: 11;
  bottom: 3px;
  left: 50%;
  margin-left: -4px;
  width: 8px;
  height: 3px;
  display: inline-block;
  border-radius: 10px;
  background: #403E49;

  transition:background 1s;
  -moz-transition:background 1s; /* Firefox 4 */
  -webkit-transition:background 1s; /* Safari and Chrome */
  -o-transition:background 1s; /* Opera */

}

.header .header-li:hover .linehover{
  background: #39C44F;
}
.header .header-ul{
  overflow: hidden;

}
.header .header-li.selected .linehover{
  background: #39C44F;
}
.header .header-li.selected{
  background: rgb(0,0,0,.3);

}
.header .header-li:hover{
  background: rgb(0,0,0,.3);
  color: #fff;

}
.header .login{
  font-size: 14px;
  color: #D8D8D8;
  float: right;
  margin-top: 20px;
}
ol, ul {
  list-style: none;
}
.placeholder {
  width: 340px;
  border: 3px solid red;
}

.logout-menu {
  color: #333;
  background: white;
  width: 80px;
  height: 30px;
  cursor: pointer;
  position: relative;
  right: -95%;
  /* left: 1150px; */
  font-size: 14px;
  text-align: center;
  padding-top: 20px;
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.08);
  z-index: 2000;
  -webkit-animation: fadeInDown .3s;
  animation: fadeInDown .3s;
}

.logout-bg {
  position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1000;
  background: rgba(0, 0, 0, 0.01);
}

@keyframes fadeInDown {
    0% {
        -webkit-transform: translate3d(0, -20%, 0);
        -webkit-transform: translate3d(0, -20%, 0);
        transform: translate3d(0, -20%, 0);
        transform: translate3d(0, -20%, 0);
        opacity: 0;
    }
    100% {
        -webkit-transform: none;
        transform: none;
        opacity: 1;
    }
}

/* 手机 */
@media screen and (max-width: 768px) {
	.logo-show {
		display: none;
  }
  .avatar-show {
    display: none !important;
  }
  .header .header-center {
    width: 90%;
  }
  .header .header-li {
    width: 80px;
  }
}

/* Pad */
@media screen and (min-width: 768px) and (max-width: 1023px) {
	.logo-show {
		display: none;
  }
  /* .avatar-show {
    display: none !important;
  } */
  .header .header-center {
    width: 90%;
  }
  .header .header-li {
    width: 100px;
  }
}

/* 中屏幕电脑 */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .logo-show {
    display: inline-block;
  }
  .header .header-center {
    width: 90%;
  }
  .header .header-li {
    width: 100px;
  }
}

/* 大屏幕电脑 */
@media screen and (min-width: 1200px) {
  .logo-show {
    display: inline-block;
  }
	.header .header-center {
    width: 90%;
  }
  .header .header-li {
    width: 100px;
  }
}
</style>
